module.exports = __webpack_public_path__ + "img/pt.622c2ae1.svg";